<template>
  <nav class="navbar navbar-expand-lg px-3 shadow-sm" :class="themeClass">
    <div class="container-fluid">
      <div class="navbar-brand mb-0 d-flex align-items-center">
        <span class="h6 mb-0">Panel de Cliente</span>
      </div>

      <div class="ms-auto d-flex align-items-center">
        <button @click="toggleTheme" class="btn btn-outline-secondary me-3" :title="isDarkMode ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'">
          <i :class="isDarkMode ? 'bi bi-sun-fill' : 'bi bi-moon-fill'"></i>
        </button>
        <span class="me-3 text-muted small">Empresa: <strong>{{ companyName }}</strong></span>
        <div class="dropdown">
          <button
            class="btn btn-outline-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            @click="toggleDropdown"
            :aria-expanded="dropdownOpen"
          >
            <i class="bi bi-person-circle me-1"></i> {{ userName }}
          </button>
          <ul class="dropdown-menu dropdown-menu-end" :class="{ show: dropdownOpen }" aria-labelledby="dropdownMenuButton">
            <li><router-link class="dropdown-item" to="/perfil" @click="closeDropdown">Mi Perfil</router-link></li>
            <li><router-link class="dropdown-item" to="/configuracion-usuario" @click="closeDropdown">Cambiar Contraseña</router-link></li>
            <li><hr class="dropdown-divider" /></li>
            <li><a class="dropdown-item text-danger" href="#" @click.prevent="cerrarSesion">Cerrar Sesión</a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import themeManager from '@/store/theme'
import auth from '@/services/servicioAutenticacion'
import { mapGetters } from 'vuex'

export default {
  name: 'ClientTopbar',
  data() {
    return {
      dropdownOpen: false
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  computed: {
    ...mapGetters(['currentUser']),
    themeClass() {
      return themeManager.themeClass
    },
    isDarkMode() {
      return themeManager.isDarkMode
    },
    companyName() {
      if (this.currentUser?.company?.business_name) {
        return this.currentUser.company.business_name
      }
      return this.currentUser?.is_super_admin ? 'Administración del Sistema' : 'Sin Empresa'
    },
    userName() {
      return this.currentUser?.name || this.currentUser?.email || 'Usuario'
    }
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    closeDropdown() {
      this.dropdownOpen = false
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.dropdown')
      if (this.dropdownOpen && dropdown && !dropdown.contains(event.target)) {
        this.dropdownOpen = false
      }
    },
    cerrarSesion() {
      auth.cerrarSesion()
      this.$router.push('/iniciar-sesion')
    },
    toggleTheme() {
      themeManager.toggleTheme()
    }
  }
}
</script>

<style>
.navbar {
  background-color: var(--bg-light) !important;
  border-bottom: 1px solid var(--border-color) !important;
  color: var(--text-primary) !important;
}

.dark-theme .navbar {
  background-color: var(--bg-dark) !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.navbar-brand {
  color: var(--text-primary) !important;
}

.dark-theme .navbar-brand {
  color: var(--text-primary) !important;
}

.text-muted {
  color: var(--text-secondary) !important;
}

.dark-theme .text-muted {
  color: var(--text-secondary) !important;
}
</style>




